import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  allPosts: {
    id: 'discussions.navigation.navigationBar.allPosts',
    defaultMessage: 'All posts',
    description: 'Option in navbar to show all posts',
  },
  allTopics: {
    id: 'discussions.navigation.navigationBar.allTopics',
    defaultMessage: 'Topics',
    description: 'Option in navbar to show all topics',
  },
  myPosts: {
    id: 'discussions.navigation.navigationBar.myPosts',
    defaultMessage: 'My posts',
    description: 'Option in navbar to show a user\'s posts',
  },
  learners: {
    id: 'discussions.navigation.navigationBar.learners',
    defaultMessage: 'Learners',
    description: 'Option in navbar to show learners',
  },

});

export default messages;
